import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'
import { Airport } from '@/travelsuit'
import { FlightBookingSegment } from '@/types/flights/booking'

import { IAction } from '../actions/action-helpers'
import { ItineraryTypes } from '../actions/actions.types'

export type AirportsState = ApplicationState['airports']

function airportsReducer(state: AirportsState = new ImmutableMap(), action: IAction): AirportsState {
	switch (action.type) {
		case ItineraryTypes.GetItinerary.SUCCESS:
			return action.payload.flights_bookings.reduce(
				(state0: AirportsState, booking: FlightBookingSegment) =>
					booking.flights.reduce(
						(state1: AirportsState, flight) =>
							flight.segments.reduce(
								(state2: AirportsState, seg) =>
									state2
										// todo: fix types Airport vs BookingAirport
										.set(Number(seg.departure_airport.id), seg.departure_airport as unknown as Airport)
										.set(Number(seg.arrival_airport.id), seg.arrival_airport as unknown as Airport),
								state1,
							),
						state0,
					),
				state,
			)
	}
	return state
}

export default airportsReducer
